import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'PROJECTS_PAGE_TOGGLE_DIALOG_OPEN',
  'PROJECTS_PAGE_SET_EDIT_PROJECT',
]);
